module.exports = __webpack_public_path__ + "media/images/help/browse_image_6-903f288be96d87030b4d2ea05c0ebc45.png";